import { BaseService } from './utils/BaseService';
import type {
  GetNotificationSettingsResponse,
  ListNotificationsQueryParams,
  ListNotificationsResponse,
  UpdateNotificationSettingsBody,
  UpdateNotificationSettingsResponse,
} from '$shared/api';

/**
 * Manages calls to the backend notification endpoints.
 * We leverage a base service client and simply specify
 * (url, method, body, or query) to perform requests.
 */
export class NotificationService extends BaseService {
  listNotifications(
    query?: ListNotificationsQueryParams,
  ): Promise<ListNotificationsResponse> {
    return this.client.send('/api/notifications', {
      method: 'GET',
      query,
    });
  }
  markAsRead(notificationIds: number[]) {
    return this.client.send('/api/notification', {
      method: 'PUT',
      body: { notificationIds },
    });
  }

  /**
   * Retrieve the user's current email notification settings for each NotificationSettingsType.
   * Returns a record of NotificationSettingsType → boolean (true = enabled, false = disabled).
   */
  getNotificationSettings(): Promise<GetNotificationSettingsResponse> {
    return this.client.send('/api/notifications/settings', {
      method: 'GET',
    });
  }

  /**
   * Update the user's email notification settings.
   * If a setting is true, the server will remove any override row (so it reverts to default "on").
   * If a setting is false, the server will insert/update an override row so it's "off".
   */
  updateNotificationSettings(
    data: UpdateNotificationSettingsBody,
  ): Promise<UpdateNotificationSettingsResponse> {
    return this.client.send('/api/notifications/settings', {
      method: 'PUT',
      body: data,
    });
  }
}
